import { render } from "./media-block.vue?vue&type=template&id=5c3f096c"
import script from "./media-block.vue?vue&type=script&lang=js"
export * from "./media-block.vue?vue&type=script&lang=js"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__